import classNames from "classnames";
import { ReactElement } from "react";
import { IconType } from "react-icons/lib";
import { Link, useLocation } from "react-router-dom";

const SettingsNavBarItem = ({
  name,
  route,
  Icon,
}: {
  name: string;
  route: string;
  Icon: IconType;
}) => {
  const location = useLocation();
  const isActive = location.pathname === route;
  return (
    <Link
      to={route}
      className={`flex flex-col gap-[17px] items-center transition `}
    >
      <p
        className={`px-[5px] font-[500] text-[14px] text-[#667085] hidden md:block transition ${isActive && " text-brand-darkYellow"} `}
      >
        {name}
      </p>

      <Icon
        className={classNames(
          { "text-brand-darkYellow": isActive },
          "block md:hidden text-2xl",
        )}
      />
      <div
        className={`w-full h-[1px] bg-brand-darkYellow transition invisible ${isActive && " !visible"}`}
      ></div>
    </Link>
  );
};

export default SettingsNavBarItem;
